class OverlappingSection {
	el: HTMLElement
	previous: HTMLElement | null
	next: HTMLElement | null
	target: HTMLElement
	mutationObserver: MutationObserver
	
	constructor(el: HTMLElement) {
		this.el = el;
		this.previous = this.el.previousElementSibling as HTMLElement;
		let next = this.el.nextElementSibling as HTMLElement | null;

		let parentNode = el.parentNode as HTMLElement | null;
		
		if (!next && parentNode && parentNode.tagName == 'MAIN') {
			let footerSection = parentNode.parentNode?.querySelector('footer section');
			if( footerSection ){
				next = footerSection as HTMLElement;
			}
		}

		this.next = next;
		this.target = el.firstChild as HTMLElement;
		this.target.style.transition = 'height 0.1s';

		this.update();

		// also update on resize
		window.addEventListener('resize', () => this.update());

		if( this.previous ){
			// check for transition
			let transition = this.previous.style.transition;
			if( !transition ){
				transition = '';
			}
			else {
				transition += ';';
			}
			transition+=' padding-bottom .1s';
			this.previous.style.transition = transition;
		}

		if( this.next ){
			// check for transition
			let transition = this.next.style.transition;
			if( !transition ){
				transition = '';
			}
			else {
				transition += ';';
			}
			transition+=' padding-top .1s';
			this.next.style.transition = transition;
		}

		// do we need to poll for updates too? for more dynamic
		// content
		// setInterval( () =>  this.update(), 100 );

		this.mutationObserver = new MutationObserver( () => this.update() );
		this.mutationObserver.observe( this.el, {
			subtree: true,
			childList: true,
			attributes: true
		})
	}

	update() {

		// this.target.style.height = '';
		const height = this.target.offsetHeight;
		// this.target.style.height = this.target.offsetHeight+'px';
		const half = (height / 2) + 'px';
		// check for padding on this element
		let padding = '';
		
		if (this.previous) {
			padding = 'calc(' + half + ' + var(--sb-section-padding-bottom, var(--sb-section-padding, var(--space-xl))))';
			this.previous.style.paddingBottom = padding;
		}
		if (this.next) {
			padding = 'calc(' + half + ' + var(--sb-section-padding-top, var(--sb-section-padding, var(--space-xl))))';
			this.next.style.paddingTop = padding;
		}

		this.el.style.visibility = 'visible';	
	}
}

export default {
	init(el: HTMLElement) {
		new OverlappingSection(el);
	}
}